import styled from 'styled-components';

export const DrawerWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
